//
//
//
//
import echarts from "echarts";
import { debounce } from '@/utils';
export default {
  props: ["chartData", "lendName", "xAxisData"],
  data: function data() {
    return {
      chart: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.initChart();
    this.__resizeHanlder = debounce(function () {
      if (_this.chart) {
        _this.chart.resize();
      }
    }, 100);
    window.addEventListener("resize", this.__resizeHanlder);
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.chart) {
      return;
    }

    this.chart.dispose();
    this.chart = null;
    window.removeEventListener('resize', this.__resizeHanlder);
  },
  watch: {
    chartData: {
      deep: true,
      handler: function handler(val) {
        this.setOptions(val);
      }
    }
  },
  methods: {
    setOptions: function setOptions() {
      this.chart.setOption({
        //       label: {
        //     backgroundColor: '#6a7985'
        //   },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.xAxisData,
          axisLine: {
            lineStyle: {
              type: 'dashed',
              color: '#fff'
            }
          }
        },
        yAxis: {
          type: "value",
          splitNumber: 1,
          min: 1 // splitLine: {
          //   type: 'dashed',
          //   color: '#fff',
          // }

        },
        grid: {
          left: "6%",
          right: "6%",
          bottom: "12%",
          top: "6%"
        },
        series: [{
          data: this.chartData,
          type: "line",
          backgroundStyle: {},
          itemStyle: {
            color: "#29a7fe"
          },
          areaStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
              offset: 0,
              color: "#6bcfc8"
            }, {
              offset: 1,
              color: "#6abae6"
            }])
          },
          smooth: true
        }]
      });
    },
    initChart: function initChart() {
      console.log(this.chartData);
      this.chart = echarts.init(this.$refs.statusEchart, "macarons");
      this.setOptions(this.chartData);
    }
  }
};